import { css } from '@linaria/core';
import { theming, baseUnits } from 'styles/utils';
export const inputStyles = "omponents__Input__components__InputWithIcon__InputWithIcon_styles_ts-inputStyles-i1qr754u";

require("./InputWithIcon.styles.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./InputWithIcon.styles.ts");